module.exports = __webpack_public_path__ + "img/thumb-oamm2a.d8aa1531.jpg";